import {IServiceFactory} from "../../../../service-factory.interface";
import {MealSsrBase} from "../meal-ssr-base";

//Meniu Spaghete cu legume
export default class SpmlSsrType extends MealSsrBase {
    constructor(services: IServiceFactory) {
        super('SPML', services);
    }
}
